module.exports = __webpack_public_path__ + "static/img/29.6b3da7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/29.jpg
// module id = 8bHH
// module chunks = 0